// 账户管理
import accountManage from '@/views/accountManage/accountManage'
import projectManage from '@/views/accountManage/projectManage'
import createProject from '@/views/accountManage/createProject'
import authCallback from '@/views/accountManage/authCallback'
import putInAccountManage from '@/views/accountManage/putInAccountManage'
import staffManage from '@/views/accountManage/staffManage'
import agentManage from '@/views/accountManage/agentmanage/index'
import roleManage from '@/views/accountManage/roleManage'
import accountConvertLink from '@/views/accountManage/accountConvertLink'
export default {
  path: '/accountManage',
  name: 'accountManage',
  component: accountManage,
  meta: {
    keepAlive: true,
    title: '账户管理',
    code: 'page:accountManage',
    activeName: '/accountManage',
    permission: 'account',
    name: 'projectManage'
  },
  children: [
    {
      path: 'projectManage',
      name: 'projectManage',
      component: projectManage,
      meta: {
        keepAlive: true,
        title: '项目管理',
        iconName: 'icon-menuXm',
        permission: 'projectManagement'
      },
      children: [
        {
          path: 'createProject',
          name: 'createProject',
          component: createProject,
          meta: {
            keepAlive: true
          }
        }
      ]
    },
    {
      path: 'putInAccountManage',
      name: 'putInAccountManage',
      component: putInAccountManage,
      meta: {
        keepAlive: true,
        title: '投放账户管理',
        iconName: 'icon-menuTf',
        permission: 'accountManagement'
      },
      children: [
        {
          path: '/accountManage/authCallback',
          name: 'authCallback',
          component: authCallback,
          meta: {
            keepAlive: false
          }
        }
      ]
    },
    {
      path: 'staffManage',
      name: 'staffManage',
      component: staffManage,
      meta: {
        keepAlive: true,
        title: '员工管理',
        iconName: 'icon-menuYg',
        permission: 'employeeManagement'
      },
      children: [
        {
          path: 'createEmployees',
          name: 'createEmployees',
          component: resolve => require(['@/views/accountManage/createEmployees'], resolve),
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'modifyEmployees',
          name: 'modifyEmployees',
          component: resolve => require(['@/views/accountManage/modifyEmployees'], resolve),
          meta: {
            keepAlive: true
          }
        }
      ]
    },
    {
      path: 'agentManage',
      name: 'agentManage',
      component: agentManage,
      meta: {
        keepAlive: true,
        title: '代理商管理',
        iconName: 'icon-dailishangguanli',
        permission: 'agencyManagement'
      }
    },
    {
      path: 'roleManage',
      name: 'roleManage',
      component: roleManage,
      meta: {
        keepAlive: true,
        title: '角色权限管理',
        iconName: 'icon-roleManage',
        permission: 'role:list'
      },
      children: [
        {
          path: 'roleAuthorization',
          name: 'roleAuthorization',
          component: resolve => require(['@/views/accountManage/roleAuthorization'], resolve),
          meta: {
            keepAlive: true,
            title: '角色授权'
          }
        }
      ]
    },
    {
      path: 'accountConvertLink',
      name: 'accountConvertLink',
      component: accountConvertLink,
      meta: {
        keepAlive: true,
        title: '电商转链',
        iconName: 'icon-link',
        permission: 'transfer:link'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/modules/account.js